import { TrackingStatus } from 'src/types';
import { IKameleoonData, IdentifierDataType, KameleoonData } from './types';

export class UniqueIdentifier implements IKameleoonData {
  public status: TrackingStatus;

  private _value: boolean;

  /**
   * @param {boolean} value - a boolean value that indicates if the visitor has a unique identifier
   * */
  constructor(value: boolean) {
    this._value = value;
    this.status = TrackingStatus.Sent;
  }

  get url(): string {
    return '';
  }

  get data(): IdentifierDataType {
    return {
      value: this._value,
      type: KameleoonData.UniqueIdentifier,
      status: TrackingStatus.Sent,
    };
  }

  /**
   * @private
   * @method _fromRaw - an internal method for creating a UniqueIdentifier instance from raw data
   * @param {IdentifierDataType} data - a raw data
   * @return {UniqueIdentifier} a UniqueIdentifier instance
   * */
  public static _fromRaw(data: IdentifierDataType): UniqueIdentifier {
    return new UniqueIdentifier(data.value);
  }
}
